import React, { Component, useState, useRef } from "react";
import {
  makeStyles,
  withStyles,
  useTheme,
  styled,
} from "@material-ui/core/styles";
import Save from "../../../../Assets/img/svg/save.svg";
import Cancel from "../../../../Assets/img/svg/cancel.svg";
import image from "../../../../Assets/img/svg/Image.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { DragIndicator } from "@material-ui/icons";
import {
  TextField,
  InputBase,
  InputAdornment,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Autocomplete from "react-autocomplete";
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "../../../../Assets/jss/customStyle";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import $ from "jquery";
import moment from "moment";
import Delete from "../../../../Assets/img/svg/delete.svg";
import axios from "axios";
import API from "../../../../helpers/endpointService";
import del from "../../../../Assets/img/svg/Del.svg";
import { CssTextField } from "../../../custom/textField";
import { inspectionSystem } from "../../../Constants";
import InnerImageZoom from "react-inner-image-zoom";
import { putShortSummaryDesc } from "../../../../actions/InspectionActions"
import { htmlDecode, htmlEncode, ReportDesc } from "../EncodeDecode.js"
import {warningAlert,successAlert} from "../../../custom/alert"
import { successToast, errorToast } from "../../../../actions/CommonFunction";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const useStyles = makeStyles((theme) => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  error: {
    color: "#f44336",
  },
  helperText: {
    "& p": {
      marginLeft: "0px !important",
    },
  },
  button: {
    background: "#FFFFFF",
    border: "none",
    boxSizing: "border-box",
    borderRadius: "7px",
  },
}));

const BootstrapError = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #f44336",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}))(InputBase);

const names = ["Oliver Hansen", "Van Henry", "April Tucker", "Ralph Hubbard"];

const CheckboxWithBlackCheck = withStyles({
  root: {
    "& .MuiSvgIcon-root": {
      fill: "#FFFFFF",
      width: 20,
      height: 20,
      border: "1px solid #000000",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    "&$checked": {
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
        backgroundColor: "#FFFFFF",
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        height: 10,
        width: 10,
        position: "absolute",
        backgroundColor: "#000000",
        zIndex: -1,
      },
    },
  },
  checked: {},
})(Checkbox);

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

class AddEditCSN extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      isMobile: false,
      Docs: [],
      cancel: false,
      DelIndex: 0,
      awsname: "",
      filename: "",
      addDescription: {
        "Id": 0,
        "ShipId": 0,
        "SectionId": 0,
        "Description": "",
        "IsDeleted": true,
        "InspectionId": 0,
        "CreatedBy": "",
        "ModifiedBy": "",
        "ReportDescription": ""
      },
      CancelSummary: "",
    };
  }



  componentDidMount() {
    let Shipid = parseInt(localStorage.getItem("DashId"));
    let inspectioid = parseInt(localStorage.getItem("InspectionId"));
    this.state.addDescription.ShipId = Shipid;
    this.state.addDescription.InspectionId = inspectioid;
    this.state.addDescription.ModifiedBy = localStorage.getItem("UserRoles");
    this.state.addDescription.SectionId = inspectionSystem.ConcludingStatement;
    this.setState({});
    const { dispatch } = this.props;
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
    if (Shipid !== 0 && inspectioid !== 0) {
      this.getSummaryDesc(Shipid, inspectioid);
    }
    window["summernote_addEditDesc"]();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.resize.bind(this));
    this.props.dispatch({ type: "RICHTEXT", data: false });
    this.props.dispatch({ type: "RICHTEXT1", data: false });
    $("#CON1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Concluding1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#Concluding").addClass("d-none");
    $("#Concluding").removeClass("d-block");
    $("#CSL").removeClass("active-color");
    $("#CST").removeClass("fw-bolder");
  }
  sidebar = () => {
    if (this.state.cancel === true) {
      window.$("#cancelpopup1").modal("show");
    } else {
      this.props.navigate("/sidebar");
    }
  };
  SideBarCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup1").modal("hide");
    this.props.navigate("/sidebar");
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  resize1 = () => {
    $("#CON1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Concluding1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#Concluding").removeClass("d-none");
    $("#Concluding").addClass("d-block");
    $("#CSL").addClass("active-color");
    $("#CST").addClass("fw-bolder");
  };
  AddCancel1 = () => {
    let SummeryResult = window["getsummernote_code"]();
    if ((this.state.cancel == true) || (this.state.CancelSummary != SummeryResult && SummeryResult != '<p><br></p>')) {
      window.$("#cancelpopup").modal("show");
    } else {
      this.props.dispatch({ type: "CANCEL", data: false });
      this.props.dispatch({ type: 'RICHTEXT', data: false });
      this.props.navigate(`/shiplist`);
    }
  };
  AddCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    this.props.dispatch({ type: 'RICHTEXT', data: false });
    window.$("#cancelpopup").modal("hide");
    this.props.navigate("/shiplist");
  };

  getSummaryDesc = (id, inspection) => {
    const { dispatch } = this.props;
    let apiUrl = `${API.Get_Richtext}?ShipId=${id}&InspectionId=${inspection}&SectionId=${inspectionSystem.ConcludingStatement}`;
    dispatch({ type: "SHOW_LOADER", data: true })
    axios.get(apiUrl)
      .then((response) => {
        if (response?.status === 200) {
          this.props.dispatch({ type: 'RICHTEXT', data: true })
          if (response?.data.Description !== null && response?.data.Id !== 0) {
            this.state.addDescription = response?.data;
            this.setState({})
            let result = htmlDecode(this.state.addDescription.Description);
            this.setState({
              CancelSummary: result
            })
            this.props.dispatch({ type: 'RICHTEXT_CANCEL', data: this.state.CancelSummary })
            window["getsummernote_code"](result)
          }
          dispatch({ type: "SHOW_LOADER", data: false })
        } else {

        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) { }
      });
  }
  addSummaryDesc = (data) => {
    let apiUrl = API.AddEdit_Richtext;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          this.state.addDescription.Id = response?.data;
          this.setState({})
          let SummeryResult = window["getsummernote_code"]();
          this.state.CancelSummary = SummeryResult;
          this.props.dispatch({ type: 'RICHTEXT_CANCEL', data: SummeryResult })
            //successAlert("Data saved successfully.");
            successToast();
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });

  }
  AddSave = () => {
    const { dispatch } = this.props;
    let SummeryResult = window["getsummernote_code"]();
    this.props.dispatch({ type: "CANCEL", data: false });
    if (this.state.addDescription.Id === 0) {
      this.state.addDescription.CreatedBy = localStorage.getItem("UserRoles");
      this.state.addDescription.ModifiedBy = "";
      this.state.addDescription.Description = htmlEncode(SummeryResult);
      let ReportResult = ReportDesc(SummeryResult);
      this.state.addDescription.ReportDescription = htmlEncode(ReportResult);
      this.setState({})
      this.addSummaryDesc(this.state.addDescription);
      this.setState({ cancel: false })
      this.props.dispatch({ type: "CANCEL", data: false });
    } else {
      this.state.addDescription.CreatedBy = "";
      this.state.addDescription.ModifiedBy = localStorage.getItem("UserRoles");
      this.state.addDescription.Description = htmlEncode(SummeryResult);
      let ReportResult = ReportDesc(SummeryResult);
      this.state.addDescription.ReportDescription = htmlEncode(ReportResult);
      this.setState({})
      this.putShortSummaryDesc(this.state.addDescription, this.state.addDescription.Id);
      this.props.dispatch({ type: "CANCEL", data: false });
    }
  };

  putShortSummaryDesc = (data, id) => {
    let apiUrl = `${API.AddEdit_Richtext}?id=${id}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          let SummeryResult = window["getsummernote_code"]();
          this.state.CancelSummary = SummeryResult;
          this.props.dispatch({ type: 'RICHTEXT_CANCEL', data: SummeryResult })
            //successAlert("Data saved successfully.");
            successToast();
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) { }
      });
  }

  render() {
    let { classes, menuToggle } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4 mob-topfixed ">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={this.sidebar}>
                    <ListItemText
                      id={"CON" + "1"}
                      className="  textNaviIcon"
                      primary="Inspection Tasks"
                    />
                    <NavigateNextIcon
                      id="CON"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                <h4>Concluding Statement</h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="ml-auto scroll-hide mt-138"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
                ? "calc(100% - 240px)"
                : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      className="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td className="border-right text-center">
                    <button className={classes.button} onClick={this.AddSave}>
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                  </td>
                  <td className="text-center">
                    <button
                      className={classes.button}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <table className="dataTable" width="100%">
              <tbody>
                <tr>
                  <td width="5%" className="border-right text-center">
                    <i
                      className="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td width="95%">
                    <button className={classes.button} onClick={this.AddSave}>
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                    <button
                      className={`${classes.button} pl-3`}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
            {this.state.isMobile ? (
              ""
            ) : (
              <h6 className="col-12 mx-2 pt-2 ml-1">Concluding Statement</h6>
            )}
            <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
              <div className={`row mx-1 mb-2 pt-2 p-0 ${this.state.isMobile ? "" : " "}`}>
                <div className={this.state.isMobile ? "col-12 pt-2 mt-1" : "col-12 p-0 pt-2 mt-1"}>
                  <div className="" id="summernote"></div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade p-5 mt-5"
            id="cancelpopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cancelpopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div className="modal-dialog" role="document">
              <div
                className={
                  this.state.isMobile ?"modal-content" : "modal-content p-3"
                }
              >
                <div className="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 className="fw-bold">
                    Changes are not saved yet. The data will be lost. Do you really want to cancel?
                    </h5>{" "}
                  </div>
                </div>
                <div className="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#499AC8", border: "none" }}
                    onClick={this.AddCancel}
                  >
                    <span className="">Yes</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal1"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#cancelpopup").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">No</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade p-5 mt-5"
            id="deletepopup"
            tabindex="-1"
            role="dialog"
            aria-labelledby="deletepopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div className="modal-dialog" role="document">
              <div
                className={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div className="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 className="fw-bold">
                      Are you sure you want to delete?
                    </h5>{" "}
                  </div>
                </div>
                <div className="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    style={{ backgroundColor: "#499AC8", border: "none" }}
                    onClick={() => this.DeleteItem()}
                  >
                    <span className="">Delete</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal"
                    className={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#deletepopup").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal fade p-5 mt-5"
            id="cancelpopup1"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cancelpopupLabel"
            aria-hidden="true"
            style={{
              top: "13%",
              left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
            }}
          >
            <div class="modal-dialog" role="document">
              <div
                class={
                  this.state.isMobile ? "modal-content" : "modal-content p-3"
                }
              >
                <div class="modal-body pb-0">
                  <h1 className="text-center">
                    <img src={del}></img>
                  </h1>
                  <div className="text-center">
                    <h5 class="fw-bold">
                    Changes are not saved yet. The data will be lost. Do you really want to cancel?
                    </h5>{" "}
                  </div>
                </div>
                <div class="modal-footer border-top-0 m-auto">
                  <button
                    type="button"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    data-dismiss="modal"
                    style={{ backgroundColor: "#499AC8", border: "none" }}
                    onClick={this.SideBarCancel}
                  >
                    <span className="">Yes</span>
                  </button>
                  <button
                    type="button"
                    id="closemodal1"
                    class={
                      this.state.isMobile
                        ? "btn btn-secondary"
                        : " btn btn-secondary py-2 px-4"
                    }
                    onClick={() => window.$("#cancelpopup1").modal("hide")}
                    style={{
                      backgroundColor: "#EBEBEB",
                      border: "none",
                      color: "#111010",
                    }}
                  >
                    <span className="">No</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    settings: state.commonReducer.settings || [],
  };
}

AddEditCSN.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddEditCSN))
);
